/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */


export const myAccountBoxStyle = {
  box: {
    padding: "0.25rem 1rem 1rem",
  },
  heading: {
    color: "primary.main",
  },
  gridSpace: {
    paddingRight: "3rem",
  },
  buttonSpace: {
    paddingTop: "1rem",
  },
  dividerHeading: {
    color: "black",
    paddingBottom: "1rem",
    margin: "4rem 0 1rem",
    borderBottom: "1px solid #333333",
  },
  accountDataPageBox: {
    padding: "1rem",
    margin: "25px 0",
  },
  verticalSpace: {
    height: "1rem",
  },
};
